export default __webpack_public_path__ + "static/education-equity-accomplishment-2-f839023343e48a1ad4d26328d90c667a.webp";